import { atom } from "recoil";
const tableState = atom({
  key: "table", // unique ID (with respect to other atoms/selectors)
  default: {}, // default value (aka initial value)
});
export const tablePageState = atom({
  key: "tablePage", // unique ID (with respect to other atoms/selectors)
  default: 0, // default value (aka initial value)
});
export default tableState;
